import { Box, Button, Grid, styled, Typography } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridSelectionModel,
  GridToolbar,
  GridValueGetterParams,
} from "@mui/x-data-grid";
import * as React from "react";
import { useEffect, useState } from "react";
import { BACKEND_URL } from "../../../../api/api";
import { useCreateKandidatFile } from "../../../../api/effects/mutations/Kandidat/useCreateKandidatFile";
import { useCreateMultipleKandidatFile } from "../../../../api/effects/mutations/Kandidat/useCreateMultipleKandidatFile";
import { useDownloadKandidatFile } from "../../../../api/effects/mutations/Kandidat/useDownloadKandidatFile";
import useFetchAllKandidat from "../../../../api/effects/queries/Kandidat/useFetchAllKandidat";
import useFetchAllPendidikan from "../../../../api/effects/queries/Pendidikan/useFetchAllPendidikan";
import useFetchAllPertanyaan from "../../../../api/effects/queries/Pertanyaan/useFetchAllPertanyaan";
import { KandidatResponse } from "../../../../models/Kandidat";
import { PendidikanResponse } from "../../../../models/Pendidikan";
import { PertanyaanResponse } from "../../../../models/Pertanyaan";
import { getCookie } from "../../../../utils/cookies";
import { convertDateTime } from "../../../../utils/dateConvert";
import { CustomToolbar } from "../../HeaderHR";
import KandidatModal from "./KandidatModal";

const BoxTable = styled(Box)({
  maxWidth: "1280px",
  height: "70vh",
  width: "100%",
});

export default function KandidatTable() {
  const [ID, setID] = useState(-1);
  const setIDAsync = async (e: number) => {
    setID(e);
  };
  const { mutateAsync: DownloadFile } = useDownloadKandidatFile({
    onSuccess(res) {
      const url = window.URL.createObjectURL(new Blob([res.data]));
      const link = document.createElement("a");
      link.href = url;
      var filename = "";
      const disposition = res.headers["content-disposition"];
      if (disposition && disposition.indexOf("attachment") !== -1) {
        var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
        var matches = filenameRegex.exec(disposition);
        if (matches != null && matches[1]) {
          filename = matches[1].replace(/['"]/g, "");
        }
      }
      link.setAttribute("download", filename); //or any other extension
      document.body.appendChild(link);
      link.click();
      console.log("Download Success");
    },
    onError() {
      console.log("Download Error");
    },
  });

  const { mutateAsync: CreateFile } = useCreateKandidatFile({
    onSuccess() {
      DownloadFile(ID);
      console.log("Create Success");
    },
    onError() {
      console.log("Create Error");
    },
  });

  const token = getCookie("token");

  const columns: GridColDef[] = [
    { field: "NAMA", headerName: "Kandidat", minWidth: 200, flex: 1 },
    { field: "JOB", headerName: "Job", minWidth: 200, flex: 1 },
    {
      field: "TANGGAL_APPLY",
      headerName: "Tanggal Apply",
      minWidth: 200,
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        return convertDateTime({ date: new Date(params.row.TANGGAL_APPLY) });
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "Resume",
      headerName: "Resume",
      sortable: false,
      minWidth: 120,
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          setIDAsync(params.row.KANDIDAT_ID).then(() =>
            CreateFile(params.row.KANDIDAT_ID)
          );
        };
        return <Button onClick={onClick}>Download</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "View",
      headerName: "View",
      sortable: false,
      minWidth: 120,
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          // CreateFile(params.row.KANDIDAT_ID).then(() =>
          window.open(
            `${window.location.origin}/KandidatFile/${params.row.KANDIDAT_ID}`
          );
          // );
        };
        return <Button onClick={onClick}>View</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
    {
      field: "action",
      headerName: "Action",
      sortable: false,
      minWidth: 150,
      flex: 1,
      renderCell: (params: GridValueGetterParams) => {
        const onClick = () => {
          handleOpenModalEdit(params.row.KANDIDAT_ID);
        };
        return <Button onClick={onClick}>Schedule Interview</Button>;
      },
      headerAlign: "center",
      align: "center",
    },
  ];
  const { data: allKandidatData } = useFetchAllKandidat();

  const [data, setData] = useState<KandidatResponse[]>();

  useEffect(() => {
    if (allKandidatData !== undefined) {
      setData(allKandidatData);
    }
  }, [allKandidatData]);

  const [IDState, setIDState] = useState(-1);
  const [modalState, setModalState] = useState(false);

  const handleOpenModalEdit = (e: number) => {
    setIDState(e);
    setModalState(!modalState);
  };

  const handleCloseModal = () => {
    setModalState(!modalState);
  };

  const [selectionModel, setSelectionModel] = useState<GridSelectionModel>([]);

  const { mutateAsync: CreateMultipleKandidatFile } =
    useCreateMultipleKandidatFile({
      onSuccess() {
        for (let index = 0; index < selectionModel.length; index++) {
          const element = Number.parseInt(selectionModel[index].toString());
          setIDAsync(element).then(() => DownloadFile(element));
        }

        console.log("Success");
      },
      onError() {
        console.log("Error");
      },
    });

  const handleDownloadMultiple = () => {
    const arr = new Array();
    for (let index = 0; index < selectionModel.length; index++) {
      const element = selectionModel[index];
      arr.push(element);
    }
    CreateMultipleKandidatFile(arr);
  };

  return (
    <>
      <KandidatModal
        open={modalState}
        handleClose={handleCloseModal}
        ID={IDState}
      />

      <Grid
        container
        justifyContent="flex-start"
        sx={{
          maxWidth: "1280px",
          paddingBottom: "1vh",
        }}
      >
        <Typography variant="h4">Tabel Kandidat</Typography>
      </Grid>
      <BoxTable>
        {data !== undefined ? (
          <DataGrid
            rows={data}
            columns={columns}
            pageSize={10}
            rowsPerPageOptions={[10]}
            getRowId={(data) => data.KANDIDAT_ID}
            disableColumnMenu
            components={{ Toolbar: CustomToolbar }}
            checkboxSelection
            disableSelectionOnClick
            onSelectionModelChange={(newSelectionModel) => {
              setSelectionModel(newSelectionModel);
            }}
            selectionModel={selectionModel}
          />
        ) : (
          <div />
        )}
      </BoxTable>

      <Grid
        container
        justifyContent="flex-end"
        sx={{
          maxWidth: "1280px",
          paddingTop: "2vh",
        }}
      >
        <Button variant="contained" onClick={handleDownloadMultiple}>
          Download Selected
        </Button>
      </Grid>
    </>
  );
}
